import { getConsentByTemplateId } from './getConsent';
import { TEMPLATE_IDS } from './templateIds';
import type { UC_UI_Props } from './types';
import { isInitialized, showSecondLayer } from './ucFunctions';

declare global {
    interface Window {
        UC_UI?: UC_UI_Props;
    }
}

export const UC_UI = {
    getConsentByTemplateId,
    showSecondLayer,
    isInitialized
};

export { TEMPLATE_IDS };
